<div class="js-recaptcha" [ngClass]="class" #recaptcha [id]="random_id"></div>